/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MultipartUploadMetadata {
    getFixupPrototypeFunction() { return MultipartUploadMetadata.fixupPrototype; }

    static newInstance(model: Partial<MultipartUploadMetadata>): MultipartUploadMetadata {
        let obj = Object.assign(new MultipartUploadMetadata(), model);
        MultipartUploadMetadata.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MultipartUploadMetadata>): MultipartUploadMetadata {
        if (!model) return null;
        return MultipartUploadMetadata.newInstance(<MultipartUploadMetadata> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MultipartUploadMetadata) {
        if (!obj) return;

        models.MultipartUploadMetadata.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MultipartUploadMetadata): boolean {
        Object.setPrototypeOf(obj, MultipartUploadMetadata.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.part_number === undefined) {
            this.part_number = 0;
        }
        if (this.upload_part_size === undefined) {
            this.upload_part_size = 0;
        }
    }

    /**
     * Unique identifier for the multipart upload session
     */
    upload_id: string;

    /**
     * The sequential number of the current part in the multipart upload.
     */
    part_number: number;

    /**
     * Size of each uploaded part in bytes.
     */
    upload_part_size: number;

}
